import { Alert, AlertType } from "app/pages/full-pages/customs/alert/alert";
import { Observable, Subject } from "rxjs";

export abstract class AbAlert {

  abstract subject: Subject<Alert>;
  abstract keepAfterRouteChange: boolean;
  abstract getAlert(): Observable<any>
  abstract success(message: string, keepAfterRouteChange: boolean);
  abstract error(message: string, keepAfterRouteChange: boolean);
  abstract info(message: string, keepAfterRouteChange: boolean);
  abstract warn(message: string, keepAfterRouteChange: boolean);
  abstract showSuccessMessage(): void;
  abstract showErrorMessage(): void;
  abstract showDeleteSuccessMessage(): void;
  abstract handlerError(err: any): void;
  abstract alert(type: AlertType, message: string, keepAfterRouteChange: boolean);
  abstract clear();
}